var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalkToAdvisorReqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 75,
    viewBox: "0 0 59 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.2077 73.125L29.4994 53.3333L1.79102 73.125V9.79167C1.79102 7.69204 2.62509 5.6784 4.10975 4.19374C5.59442 2.70907 7.60805 1.875 9.70768 1.875H49.291C51.3907 1.875 53.4043 2.70907 54.8889 4.19374C56.3736 5.6784 57.2077 7.69204 57.2077 9.79167V73.125Z",
    stroke: "#FCD300",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalkToAdvisorReqIcon);
export default __webpack_public_path__ + "static/media/talk-to-advisor-req-icon.cfa603beb2db3474c219381178b3456b.svg";
export { ForwardRef as ReactComponent };